module.exports = __webpack_public_path__ + "img/icon_4.d1f74ccd.png";